export const vendorNav = [
  {
    id: 1,
    url: '/home',
    glyphIcon: 'home',
    awesomeIcon: null,
    title: 'Home'
  },
  {
    id: 2,
    url: '/requests',
    glyphIcon: 'hourglass',
    awesomeIcon: null,
    title: 'Certification Requests'
  },
  {
    id: 3,
    url: '/request/new',
    glyphIcon: 'pencil',
    awesomeIcon: null,
    title: 'Submit New Request'
  },
  {
    id: 4,
    url: '/devices',
    glyphIcon: 'hdd',
    awesomeIcon: null,
    title: 'Certified Devices'
  },
  {
    id: 5,
    url: '/labs',
    glyphIcon: null,
    awesomeIcon: 'building',
    title: 'Authorized Test Labs'
  }
];

export const labNav = [
  {
    id: 1,
    url: '/home',
    glyphIcon: 'home',
    awesomeIcon: null,
    title: 'Home'
  },
  {
    id: 2,
    url: '/lab/requests',
    glyphIcon: 'hourglass',
    awesomeIcon: null,
    title: 'Requests for Testing'
  },
  {
    id: 3,
    url: '/lab/results',
    glyphIcon: 'paste',
    awesomeIcon: null,
    title: 'Enter Test Results'
  },
  {
    id: 4,
    url: '/devices',
    glyphIcon: 'hdd',
    awesomeIcon: null,
    title: 'Certified Devices'
  },
  {
    id: 5,
    url: '/labs',
    glyphIcon: null,
    awesomeIcon: 'building',
    title: 'Authorized Test Labs'
  }
];

export const staffNav = [
  {
    id: 1,
    url: '/home',
    glyphIcon: 'home',
    awesomeIcon: null,
    title: 'Home'
  },
  {
    id: 2,
    url: '/admin/requests',
    glyphIcon: 'hourglass',
    awesomeIcon: null,
    title: 'Pending Requests'
  },
  {
    id: 3,
    url: '/admin/approval',
    glyphIcon: 'tasks',
    awesomeIcon: null,
    title: 'Approve Request',
    badgeType: 'approveCount'
  },
  {
    id: 4,
    url: '/devices',
    glyphIcon: 'hdd',
    awesomeIcon: null,
    title: 'Certified Devices'
  },
  {
    id: 5,
    url: '/labs',
    glyphIcon: null,
    awesomeIcon: 'building',
    title: 'Authorized Test Labs'
  }
];

export const accountantNav = [
  {
    id: 1,
    url: '/home',
    glyphIcon: 'home',
    awesomeIcon: null,
    title: 'Home'
  },
  {
    id: 2,
    url: '/payments',
    glyphIcon: null,
    awesomeIcon: 'money-bill-alt',
    title: 'Payments'
  }
];



// WEBPACK FOOTER //
// ./src/dictionaries/Navigation.js